<div class="thankyou-dialog">
	<div class="success-graphic" style="justify-content: center">
		<img src="assets/image/submit-success-dialog.png" alt="" />
    <div class="hang-tight-title">We're Working on Your Quotation.</div>
	</div>
	<div class="success-content">
		<div class="hang-tight-text">
      <p>
        Looks like it's taking a little longer than usual, but don't worry—we're still working on your quotation.
        There's no need to submit your request again. We'll send your quotation to your registered email as soon as it's ready.
      </p>

      <p>
        If you need any assistance, WhatsApp us at
        <a href="https://wa.me/60182789393" target="_blank" rel="noopener" class="whatsapp-link">+6018-278 9393</a>
        and our team will be happy to help.
      </p>
    </div>
		<button mat-flat-button class="secondary-btn" mat-dialog-close>
			{{ "success.close" | translate }}
		</button>
	</div>
</div>
